import mrkt_card_icontop from "../../assets/mrkt_card_icontop.webp";
import mrkt_card_icontop2 from "../../assets/mrkt_card_icontop2.webp";
import mrkt_card_icontop3 from "../../assets/mrkt_card_icontop3.webp";
import mrkt_card_icontop4 from "../../assets/mrkt_card_icontop4.webp";
import mrkt_card_icontop5 from "../../assets/mrkt_card_icontop5.webp";
import mrkt_card_icontop6 from "../../assets/mrkt_card_icontop6.webp";
import mrkt_card_icontop7 from "../../assets/mrkt_card_icontop7.webp";
import mrkt_card_icontop8 from "../../assets/mrkt_card_icontop8.webp";
import market_card_img from "../../assets/market_card_img.webp";
import market_card_img2 from "../../assets/market_card_img2.webp";
import market_card_img3 from "../../assets/market_card_img3.webp";
import market_card_img4 from "../../assets/market_card_img4.webp";
import market_card_img5 from "../../assets/market_card_img5.webp";
import market_card_img6 from "../../assets/market_card_img6.webp";
import market_card_img7 from "../../assets/market_card_img7.webp";
import market_card_img8 from "../../assets/market_card_img8.webp";

export const instCards = [
  {
    id: 1,
    img: new URL("../../assets/ch_img_one.webp", import.meta.url),
    title: "Regulatory Compliance",
    desc: "Assetly is designed to comply with international financial standards, ensuring smooth alignment with securities laws and local regulations. Institutions benefit from streamlined KYC/AML processes across multiple regions.",
  },
  {
    id: 2,
    img: new URL("../../assets/ch_img_two.webp", import.meta.url),
    title: "Seamless Tokenization",
    desc: "Assetly is designed to comply with international financial standards, ensuring smooth alignment with securities laws and local regulations. Institutions benefit from streamlined KYC/AML processes across multiple regions.",
  },
  {
    id: 3,
    img: new URL("../../assets/ch_img_three.webp", import.meta.url),
    title: "Risk Protection",
    desc: "Assetly is designed to comply with international financial standards, ensuring smooth alignment with securities laws and local regulations. Institutions benefit from streamlined KYC/AML processes across multiple regions.",
  },
  {
    id: 4,
    img: new URL("../../assets/ch_img_four.webp", import.meta.url),
    title: "Regulatory Compliance",
    desc: "Assetly is designed to comply with international financial standards, ensuring smooth alignment with securities laws and local regulations. Institutions benefit from streamlined KYC/AML processes across multiple regions.",
  },
  {
    id: 5,
    img: new URL("../../assets/ch_img_five.webp", import.meta.url),
    title: "Trusted Security",
    desc: "Assetly is designed to comply with international financial standards, ensuring smooth alignment with securities laws and local regulations. Institutions benefit from streamlined KYC/AML processes across multiple regions.",
  },
  {
    id: 6,
    img: new URL("../../assets/ch_img_six.webp", import.meta.url),
    title: "Scalable Global Access",
    desc: "Assetly is designed to comply with international financial standards, ensuring smooth alignment with securities laws and local regulations. Institutions benefit from streamlined KYC/AML processes across multiple regions.",
  },
  {
    id: 7,
    img: new URL("../../assets/ch_img_seven.webp", import.meta.url),
    title: "Custodial Integrations",
    desc: "Assetly is designed to comply with international financial standards, ensuring smooth alignment with securities laws and local regulations. Institutions benefit from streamlined KYC/AML processes across multiple regions.",
  },
  {
    id: 8,
    img: new URL("../../assets/ch_img_eight.webp", import.meta.url),
    title: "Accurate Data",
    desc: "Assetly is designed to comply with international financial standards, ensuring smooth alignment with securities laws and local regulations. Institutions benefit from streamlined KYC/AML processes across multiple regions.",
  },
];

export const instWorkFlow = [
  {
    id: "01",
    img: new URL("../../assets/ins_img_one.webp", import.meta.url),
    title: "Tokenize Real Assets",
    desc: "Easily convert real estate, bonds, commodities, or funds into digital tokens that are secure, compliant, and tradable.",
  },
  {
    id: "02",
    img: new URL("../../assets/ins_img_two.webp", import.meta.url),
    title: "Built-In Compliance",
    desc: "Meet regulatory requirements with KYC/AML, licensed custodial integrations, and transparent reporting designed for institutional standards.",
  },
  {
    id: "03",
    img: new URL("../../assets/ins_img_three.webp", import.meta.url),
    title: "Unlock Global Capital",
    desc: "Gain access to a borderless investor base and diversify funding through fractional ownership and onchain liquidity.",
  },
  {
    id: "04",
    img: new URL("../../assets/ins_img_four.webp", import.meta.url),
    title: "Scale with Infrastructure",
    desc: "Leverage Assetly’s enterprise-grade infrastructure, cross-chain interoperability, and institutional security to grow seamlessly across markets.",
  },
];

export const sidebarItems = [
  {
    path: "/dashboard",
    icon: new URL("../../assets/dashboard_icon.webp", import.meta.url),
    label: "Dashboard",
  },
  {
    path: "/profile",
    icon: new URL("../../assets/profile_icon.webp", import.meta.url),
    label: "Profile",
  },
  {
    path: "/market",
    icon: new URL("../../assets/market_icon.webp", import.meta.url),
    label: "Market",
  },
  // {
  //   path: "/stake",
  //   icon: new URL("../../assets/staking_icon.webp", import.meta.url),
  //   label: "Staking",
  // },
  // {
  //   path: "/liquidity-pool",
  //   icon: new URL("../../assets/liquidity_icon.webp", import.meta.url),
  //   label: "Liquidity pool",
  // },
  // {
  //   path: "/swap",
  //   icon: new URL("../../assets/swap_icon.webp", import.meta.url),
  //   label: "Swap",
  // },
  {
    path: "/portfolio",
    icon: new URL("../../assets/portfolio_icon.webp", import.meta.url),
    label: "Portfolio",
  },
  {
    path: "/secondarymarket",
    icon: new URL("../../assets/secondarymarket.webp", import.meta.url),
    label: "Secondary Market",
  },
];

export const adminSidebarItems = [
  {
    path: "/admin/dashboard",
    icon: new URL("../../assets/admin/admSd_dashIcon.webp", import.meta.url),
    label: "Dashboard",
  },
  {
    path: "/admin/userManagement",
    icon: new URL("../../assets/admin/admSd_usrmngIcon.webp", import.meta.url),
    label: "User Management",
  },
  {
    path: "/admin/tokenization",
    icon: new URL("../../assets/admin/admSd_tokenIcon.webp", import.meta.url),
    label: "Tokenization",
  },
  {
    path: "/admin/issuermanagement",
    icon: new URL("../../assets/admin/admSd_issuerIcon.webp", import.meta.url),
    label: "Issuers",
  },
  {
    path: "/admin/tokenmanagement",
    icon: new URL("../../assets/admin/token.png", import.meta.url),
    label: "Token Management",
  },
  {
    path: "/admin/contactmanagement",
    icon: new URL("../../assets/admin/support.webp", import.meta.url),
    label: "Contact Management",
  },
];

export const investments = [
  {
    id: 1,
    icon: new URL("../../assets/inv_icon_one.webp", import.meta.url),
    title: "Urbon Blocks",
    img: new URL("../../assets/inv_img_one.webp", import.meta.url),
    subtitle: "Global Real Estate Fund",
    desc: "A flagship tokenized real estate fund, transforming premium properties into accessible digital tokens.",
    details: [
      { label: "Asset Class", value: "Private Equity" },
      { label: "Target Returns", value: "10 - 12% p.a." },
      { label: "Fund Term", value: "Open-ended" },
      { label: "Min.Invesment", value: "USD 5,000" },
    ],
  },
  {
    id: 2,
    icon: new URL("../../assets/inv_icon_two.webp", import.meta.url),
    title: "Value Infi",
    img: new URL("../../assets/inv_img_two.webp", import.meta.url),
    subtitle: "Private villa",
    desc: "An exclusive private villa through secure tokenization, combining luxury real estate with global accessibility.",
    details: [
      { label: "Asset Class", value: "Private Equity" },
      { label: "Target Returns", value: "7.00% p.a." },
      { label: "Fund Term", value: "3 - Months" },
      { label: "Min.Invesment", value: "USD 3,000" },
    ],
  },
  {
    id: 3,
    icon: new URL("../../assets/inv_icon_three.webp", import.meta.url),
    title: "Maxi Group",
    img: new URL("../../assets/inv_img_three.webp", import.meta.url),
    subtitle: "Commercial Estate Fund",
    desc: "A tokenized commercial asset fund featuring premium villas, offering investors stable yields, secure ownership, and global accessibility.",
    details: [
      { label: "Asset Class", value: "Commercial Equity" },
      { label: "Target Returns", value: "10.33% p.a." },
      { label: "Fund Term", value: "2 - Months" },
      { label: "Min.Invesment", value: "USD 2,000" },
    ],
  },
  {
    id: 4,
    icon: new URL("../../assets/inv_icon_four.webp", import.meta.url),
    title: "Skyline Towers",
    img: new URL("../../assets/inv_img_four.webp", import.meta.url),
    subtitle: "Commercial Office Fund",
    desc: "High-rise commercial buildings across US metro cities, generating rental income.",
    details: [
      { label: "Asset Class", value: "Commercial Equity" },
      { label: "Target Returns", value: "8.50% p.a." },
      { label: "Fund Term", value: "12 - Months" },
      { label: "Min.Invesment", value: "USD 3,000" },
    ],
  },
];

export const stakeData = [
  {
    logoImg: mrkt_card_icontop5,
    cardTitle: "Value Infi",
    cardImg: market_card_img5,
    cardSubTitle: "Private Villa Collection",
    description:
      "Exclusive luxury villas tokenized for fractional global ownership.",
    details: [
      { label: "Asset Class", value: "Private Equity" },
      { label: "Target Returns", value: "7.00% p.a." },
      { label: "Fund Term", value: "3 - Months" },
      { label: "Min.Invesment", value: "USD 3,000" },
    ],
    buttonText: "Invest Now",
    activeStatus: false,
  },
  {
    logoImg: mrkt_card_icontop3,
    cardTitle: "Maxi Group",
    cardImg: market_card_img3,
    cardSubTitle: "Commercial Estate Fund",
    description:
      "A tokenized commercial asset fund featuring premium villas, offering investors stable yields, secure ownership, and global accessibility.",
    details: [
      { label: "Asset Class", value: "Commercial Equity" },
      { label: "Target Returns", value: "10.33% p.a." },
      { label: "Fund Term", value: "2 - Months" },
      { label: "Min.Invesment", value: "USD 2,000" },
    ],
    buttonText: "Invest Now",
    activeStatus: true,
  },
  {
    logoImg: mrkt_card_icontop8,
    cardTitle: " Capital Square",
    cardImg: market_card_img8,
    cardSubTitle: "Mixed-Use Real Estate Fund",
    description:
      "Tokenized access to retail, office, and residential spaces in high-demand US cities.",
    details: [
      { label: "Asset Class", value: "Real Estate Equity" },
      { label: "Target Returns", value: "8.80% p.a." },
      { label: "Fund Term", value: "12 - Months" },
      { label: "Min.Invesment", value: "USD 3,500" },
    ],
    buttonText: "Invest Now",
    activeStatus: false,
  },
  {
    logoImg: mrkt_card_icontop4,
    cardTitle: "Skyline Towers",
    cardImg: market_card_img4,
    cardSubTitle: "Commercial Estate Fund",
    description:
      "High-rise commercial buildings across US metro cities, generating rental income.",
    details: [
      { label: "Asset Class", value: "Commercial Equity" },
      { label: "Target Returns", value: "8.50% p.a." },
      { label: "Fund Term", value: "12 - Months" },
      { label: "Min.Invesment", value: "USD 3,000" },
    ],
    buttonText: "Invest Now",
    activeStatus: true,
  },
  {
    logoImg: mrkt_card_icontop7,
    cardTitle: " Harbor Heights",
    cardImg: market_card_img7,
    cardSubTitle: "Waterfront Properties Fund",
    description:
      "Tokenized luxury condos and villas near premium US waterfront locations.",
    details: [
      { label: "Asset Class", value: "Private Equity" },
      { label: "Target Returns", value: "10.00% p.a." },
      { label: "Fund Term", value: "9 - Months" },
      { label: "Min.Invesment", value: "USD 9,000" },
    ],
    buttonText: "Invest Now",
    activeStatus: false,
  },

  {
    logoImg: mrkt_card_icontop6,
    cardTitle: "MetroBlocks",
    cardImg: market_card_img6,
    cardSubTitle: "Urban Residential Fund",
    description:
      "Fractionalized access to multi-family apartments in fast-growing US cities.",
    details: [
      { label: "Asset Class", value: "Real Estate Equity" },
      { label: "Target Returns", value: "8.00% p.a." },
      { label: "Fund Term", value: "6 - Months" },
      { label: "Min.Invesment", value: "USD 7,000" },
    ],
    buttonText: "Invest Now",
    activeStatus: false,
  },
  {
    logoImg: mrkt_card_icontop,
    cardTitle: "Urbon Blocks",
    cardImg: market_card_img,
    cardSubTitle: "Global Real Estate Fund",
    description:
      "A flagship tokenized real estate fund, transforming premium properties into accessible digital tokens.",
    details: [
      { label: "Asset Class", value: "Private Equity" },
      { label: "Target Returns", value: "10 - 12% p.a." },
      { label: "Fund Term", value: "Open-ended" },
      { label: "Min.Invesment", value: "USD 5,000" },
    ],
    buttonText: "Invest Now",
    activeStatus: true,
  },
  {
    logoImg: mrkt_card_icontop2,
    cardTitle: "Value Infi",
    cardImg: market_card_img2,
    cardSubTitle: "Private villa",
    description:
      "An exclusive private villa through secure tokenization, combining luxury real estate with global accessibility.",
    details: [
      { label: "Asset Class", value: "Private Equity" },
      { label: "Target Returns", value: "7.00% p.a." },
      { label: "Fund Term", value: "3 - Months" },
      { label: "Min.Invesment", value: "USD 3,000" },
    ],
    buttonText: "Invest Now",
    activeStatus: true,
  },
];

export const portfolioHeldAsset = [
  {
    id: 1,
    icon: new URL("../../assets/inv_icon_one.webp", import.meta.url),
    title: "Urbon Blocks",
    cardImg: new URL("../../assets/inv_img_one.webp", import.meta.url),
    cardDescription: "Global Real Estate Fund",
    hoursChage: "24h Change",
    profit: " +2.5% ",
  },
  {
    id: 2,
    icon: new URL("../../assets/inv_icon_two.webp", import.meta.url),
    title: "Value Infi",
    cardImg: new URL("../../assets/inv_img_two.webp", import.meta.url),
    cardDescription: "Private villa",
    hoursChage: "24h Change",
    profit: " +2.5% ",
  },
  {
    id: 3,
    icon: new URL("../../assets/inv_icon_three.webp", import.meta.url),
    title: "Maxi Group",
    cardImg: new URL("../../assets/inv_img_three.webp", import.meta.url),
    cardDescription: "Commercial  Estate Fund",
    hoursChage: "24h Change",
    profit: " +2.5% ",
  },
  {
    id: 4,
    icon: new URL("../../assets/inv_icon_four.webp", import.meta.url),
    title: "Commercial Office Fund",
    cardImg: new URL("../../assets/inv_img_four.webp", import.meta.url),
    cardDescription: "Global Real Estate Fund",
    hoursChage: "24h Change",
    profit: " +2.5% ",
  },
];
